import React, { useEffect, useRef, useState } from "react";
import { Button } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { useNavigate } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  ClearAccountDetails,
  CleartraderJournalNew,
  setAccountType,
  setAccountTypeForDash,
  setActiveInactiveForDash,
} from "../../../store/reducers/dashboardReducer";
// import ReactTable from "../../ReactTable/ReactTable";
import { dollarUS } from "../../../utilities/formatters";
import { ReactComponent as EyeIcon } from "../../../assets/icons/NewIcons/eyeIcon.svg";
import { ReactComponent as EyeSlashedIcon } from "../../../assets/icons/NewIcons/eyeSlashedIcon.svg";
import { ReactComponent as DoubleCopyButton } from "../../../assets/icons/NewIcons/doubleCopyIcon.svg";
import { ReactComponent as CredentialButton } from "../../../assets/icons/NewIcons/credentialBtn.svg";
import { ReactComponent as WindowsIcon } from "../../../assets/icons/NewIcons/windowsIcon.svg";
import { ReactComponent as MacIcon } from "../../../assets/icons/NewIcons/appleIcon.svg";
import { ReactComponent as WebPortalIcon } from "../../../assets/icons/NewIcons/webportalIcon.svg";
import { ReactComponent as AndroidIcon } from "../../../assets/icons/NewIcons/androidIcon.svg";
import CopyToClipboard from "react-copy-to-clipboard";
import { handleCopyToClipboard } from "../../../utilities/string";
import { addCurrentAccount } from "../../../store/reducers/userProfileReducer";
import axios from "axios";
import {
  Pagination,
  PaginationItem,
  Select,
  CircularProgress,
} from "@mui/material";
import { useExpanded, useTable } from "react-table";
import Loader from "../../../reusableComponents/Loader";
import ReactTable from "../../ReactTable/ReactTable";

const AddIcon = (
  <svg
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="35" height="35" rx="17.5" fill="#010101" />
    <path
      d="M10.5 17.5H24.5M17.5 24.5V17.5L17.5 10.5"
      stroke="#0d56eb"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

const ActiveAccounts = ({ data, theme }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [newFilterValues, setNewFilterValues] = useState(data);
  const [IsLoading, setIsLoading] = useState(data);
  const [newDashboardList, setNewDashboardList] = useState(data);
  const { isActiveInactiveForDash, accountTypeForDash, accountType } =
    useSelector((state) => state.dashboard);
  const { ACCtoken } = useSelector((state) => state);
  const [params, setParams] = useState({
    page_size: 20,
    page_number: 1,
    is_Active: "",
    challenge_name: "",
    plan_type: "",
    status: "",
  });
  const filterValidParams = (params) => {
    return Object.fromEntries(
      Object.entries(params).filter(
        ([, value]) => value !== "" && value !== null
      )
    );
  };

  const fetchNewDashboards = async () => {
    try {
      setIsLoading(true);
      const filteredParams = filterValidParams(params);
      const response = await axios.get("dashboard/account-list/", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${ACCtoken}`,
        },
        params: filteredParams, // Pass params here directly
      });
      setNewDashboardList(response?.data);
    } catch (error) {
      console.error("Error fetching dashboards:", error);
    } finally {
      setIsLoading(false);
    }
  };

  // Ensure useEffect doesn't re-trigger unnecessarily
  // useEffect(() => {
  //   fetchNewDashboards();
  // }, [JSON.stringify(params)]);

  useEffect(() => {
    if (isActiveInactiveForDash == null) {
      dispatch(setActiveInactiveForDash(""));
    }
    if (accountTypeForDash == null) {
      dispatch(setAccountTypeForDash("all"));
    }
    if (accountType == null) {
      dispatch(setAccountType("all"));
    }

    const filteredByAccount =
      data &&
      data?.filter((item) => {
        // Check for 'isActiveInactiveForDash' condition
        const matchesActiveStatus =
          isActiveInactiveForDash === ""
            ? true
            : item?.is_Active === isActiveInactiveForDash;

        // Check for 'accountTypeForDash' condition
        const matchesAccountTypeForDash =
          accountTypeForDash === "all"
            ? true
            : item?.challenge_name?.toLowerCase()?.match(/\d+k/)?.[0] ===
              accountTypeForDash;

        // Check for 'accountType' condition
        const matchesAccountType =
          accountType === "all"
            ? true
            : item?.plan_type?.toLowerCase() === accountType;

        // Combine all conditions
        return (
          matchesActiveStatus && matchesAccountTypeForDash && matchesAccountType
        );
      });

    setNewFilterValues(filteredByAccount);
  }, [
    isActiveInactiveForDash,
    accountTypeForDash,
    accountType,
    data,
    dispatch,
  ]);

  const [credentialVisible, setCredentialVisible] = useState(false);

  const [credentialData, setcredentialData] = useState({});
  const handleAccountChange = (login_id, accountType, platform) => {
    dispatch(ClearAccountDetails());
    dispatch(CleartraderJournalNew());
    dispatch(addCurrentAccount({ login_id:login_id?.replace("#","%23"), platform, accountType }));
    // setTick(login_id);
    // setSelectedAccType(accountType)
  };
  const columns = [
    {
      Header: "Account",
      accessor: "login_id",
      id: "login_id",
      Cell: ({ value, row }) => (
        <p
          onClick={() => {
            handleAccountChange(
              row.original.login_id,
              row.original?.plan_type,
              row.original.platform
            );
            navigate("/AccountMetric");
          }}
          style={{ cursor: "pointer" }}
        >
          {value}
        </p>
      ),
    },
    {
      Header: "Balance",
      accessor: "balance_equity",
      id: "balance_equity",
      Cell: ({ value, row }) => {
        return (
          <p
            onClick={() => {
              handleAccountChange(
                row.original.login_id,
                row.original?.plan_type,
                row.original.platform
              );
              navigate("/AccountMetric");
            }}
            style={{ cursor: "pointer" }}
          >
            {dollarUS(JSON.parse(value)?.balance)}
          </p>
        );
      },
    },
    {
      Header: "Account Type",
      accessor: "plan_type",
      id: "plan_type",
      Cell: ({ value, row }) => (
        <p
          onClick={() => {
            handleAccountChange(
              row.original.login_id,
              row.original?.plan_type,
              row.original.platform
            );
            navigate("/AccountMetric");
          }}
          style={{ cursor: "pointer" }}
        >
          {value}
        </p>
      ),
    },
    {
      Header: "Status",
      accessor: "status",
      id: "status-column",
      Cell: ({ value, row }) => {
        return (
          <p
            onClick={() => {
              handleAccountChange(
                row.original.login_id,
                row.original?.plan_type,
                row.original.platform
              );
              navigate("/AccountMetric");
            }}
            style={{ cursor: "pointer" }}
          >
            {value}
          </p>
        );
      },
    },
    {
      Header: "Result",
      accessor: "progress",
      Cell: ({ value, row }) => (
        <p
          onClick={() => {
            handleAccountChange(
              row.original.login_id,
              row.original?.plan_type,
              row.original.platform
            );
            navigate("/AccountMetric");
          }}
          style={{ cursor: "pointer" }}
          className={`resultBox ${
            value === "Success"
              ? "Success"
              : value === "Failed"
              ? "Failed"
              : value === "In Progress"
              ? "In_Progress"
              : value === "Time Expired"
              ? "Time_Expired"
              : ""
          }`}
        >
          {value === "Success"
            ? "Success"
            : value === "Failed"
            ? "Failed"
            : value === "In Progress"
            ? "In Progress"
            : value === "Time Expired"
            ? "Time Expired"
            : "NA"}
        </p>
      ),
    },
    {
      Header: "Active/Inactive",
      accessor: "is_Active",
      Cell: ({ value, row }) => (
        <p
          onClick={() => {
            handleAccountChange(
              row.original.login_id,
              row.original?.plan_type,
              row.original.platform
            );
            navigate("/AccountMetric");
          }}
          style={{ cursor: "pointer" }}
          className={`${value === true ? "activeStatus" : "inActiveStatus"}`}
        >
          {value === true ? "Active" : "Inactive"}
        </p>
      ),
    },
    {
      Header: "Credentials",
      accessor: "credentials",
      Cell: ({ row, value }) => (
        <div className="credentialBox" style={{ paddingLeft: "20px" }}>
          <CredentialButton
            style={{ cursor: "pointer" }}
            onClick={() => {
              setCredentialVisible(!credentialVisible);
              setcredentialData(row?.original);
            }}
          />
        </div>
      ),
    },
    // {
    //   Header: "Details",
    //   accessor: "details",
    //   Cell: () => {
    //     const [isAccountVisible, setIsAccountVisible] = useState(true);

    //     return (
    //       <div className="visibilityDetailBox">
    //         <div className="visibilityDetailBtns">
    //           <button
    //             className={`eyeIconBtn ${
    //               isAccountVisible === true ? "slashedEyeBtn" : "inactiveEyeBtn"
    //             }`}
    //             onClick={() => setIsAccountVisible(true)}
    //           >
    //             <EyeSlashedIcon />
    //           </button>
    //           <button
    //             className={`eyeIconBtn ${
    //               isAccountVisible === false ? "hiddenEyeBtn" : "eyeBtn"
    //             }`}
    //             onClick={() => setIsAccountVisible(false)}
    //           >
    //             <EyeIcon />
    //           </button>
    //         </div>
    //       </div>
    //     );
    //   },
    // },
    // {
    //   Header: "Action",
    //   accessor: "action",
    //   Cell: ({ row }) => {
    //     const index = row.index;
    //     const [anchorEl, setAnchorEl] = useState(null);
    //     const open = Boolean(anchorEl);

    //     const handleMenuClick = (event) => {
    //       setAnchorEl(event.currentTarget);
    //     };

    //     const handleMenuClose = () => {
    //       setAnchorEl(null);
    //     };
    //     const navigate = useNavigate();
    //     return (
    //       <div className="actionDropdownContainer">
    //         <Button
    //           id={`action-button-${index}`}
    //           aria-controls={open ? `action-menu-${index}` : undefined}
    //           aria-haspopup="true"
    //           aria-expanded={open ? "true" : undefined}
    //           onClick={handleMenuClick}
    //         >
    //           <ThreeDotIcon />
    //         </Button>
    //         <Menu
    //           id={`action-menu-${index} dashboard_menulist`}
    //           anchorEl={anchorEl}
    //           open={open}
    //           onClose={handleMenuClose}
    //           MenuListProps={{
    //             "aria-labelledby": `action-button-${index}`,
    //           }}
    //           anchorOrigin={{
    //             vertical: "bottom",
    //             horizontal: "right",
    //           }}
    //           transformOrigin={{
    //             vertical: "top",
    //             horizontal: "right",
    //           }}
    //           className="dashboard-menulist"
    //         >
    //           {/* <MenuItem
    //             onClick={() => {
    //               setCredentialVisible(!credentialVisible);
    //               handleMenuClose();
    //               setcredentialData(row?.original)
    //             }}
    //             className="actionMenuDropdownItems"
    //           >
    //             Credentials
    //           </MenuItem> */}
    //           <MenuItem
    //             className="actionMenuDropdownItems"
    //             onClick={() => {
    //               handleMenuClose();
    //               handleAccountChange(
    //                 row.original.login_id,
    //                 row.original?.plan_type,
    //                 row.original.platform
    //               );
    //               navigate("/AccountMetric");
    //             }}
    //           >
    //             Account Metrics
    //           </MenuItem>
    //           {/* <MenuItem
    //             className="actionMenuDropdownItems"
    //             onClick={handleMenuClose}
    //           >
    //             Analysis
    //           </MenuItem> */}
    //         </Menu>
    //       </div>
    //     );
    //   },
    // },
  ];

  const [accountSize, setAccountSize] = useState(250000);

  const handleAccntSizeFilter = (value) => {
    setAccountSize(value);
    console.log(value, "handleAccntSizeFilter");
  };

  const accntSizeFilterOptions = [
    {
      name: "All",
      value: null,
    },
    {
      name: "5K",
      value: 5000,
    },
    {
      name: "10K",
      value: 10000,
    },
    {
      name: "25K",
      value: 25000,
    },
    {
      name: "50K",
      value: 50000,
    },
    {
      name: "100K",
      value: 100000,
    },
    {
      name: "200K",
      value: 200000,
    },
  ];
  const statusOptions = [
    {
      name: "All",
      value: "",
    },
    {
      name: "Active",
      value: true,
    },
    {
      name: "Inactive",
      value: false,
    },
  ];

  const [filterVisibility, setFilterVisibility] = useState(false);
  const filterRef = useRef(null);
  const buttonRef = useRef(null);

  const handleClickOutside = (event) => {
    if (
      filterRef.current &&
      !filterRef.current.contains(event.target) &&
      buttonRef.current &&
      !buttonRef.current.contains(event.target)
    ) {
      setFilterVisibility(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const user_profile = useSelector((state) => state.user);
  const [plans, setPlans] = useState([]);

  // const accntTypeOptions = ["All", ...plans.map((plan) => plan.plan_type)];
  const accntTypeOptions = [
    {
      name: "All",
      value: "All",
    },
    {
      name: "Alpha One",
      value: "Alpha One",
    },
    {
      name: "Alpha Pro",
      value: "Alpha pro",
    },
    {
      name: "Swing Plan",
      value: "Swing Plan",
    },
    {
      name: "Free Trial",
      value: "Free Trial",
    },
    {
      name: "Alpha Three",
      value: "Alpha Three",
    },
  ];

  useEffect(() => {
    if (data?.length) {
      // Normalize `plan_type` to lowercase for uniqueness
      const uniquePlanTypes = [
        ...new Map(
          data.map((item) => [item.plan_type?.toLowerCase(), item])
        ).values(),
      ];
      setPlans(uniquePlanTypes);
    }
  }, [data]);

  return (
    <div className="dashboardPage">
      {/* {<Loader open={IsLoading} />} */}
      <div className="dashboardPageContainer">
        <div className="headerSection">
          <div className="filter_container">
            <div className="statusBtns">
              {statusOptions.map((item) => (
                <button
                  // className={
                  //   item.value === params?.is_Active
                  //     ? "activeStatus"
                  //     : "inActiveStatus"
                  // }
                  // onClick={() =>
                  //   setParams((pre) => ({
                  //     ...pre,
                  //     is_Active: item.value,
                  //     page_number: 1,
                  //   }))
                  // }
                  className={
                    item.value === isActiveInactiveForDash
                      ? "activeStatus"
                      : "inActiveStatus"
                  }
                  onClick={() => dispatch(setActiveInactiveForDash(item.value))}
                >
                  {item.name}
                </button>
              ))}
            </div>
            <div className="filterBtn">
              <button
                ref={buttonRef}
                onClick={() => setFilterVisibility((prev) => !prev)}
              >
                Filter
              </button>
              <div
                ref={filterRef}
                className={`filterDropdownBox ${
                  filterVisibility ? "filterVisible" : "filterHidden"
                }`}
              >
                <div className="acntSizeFilter">
                  <p>Account Size</p>
                  <div className="filterOptionWrapper">
                    {accntSizeFilterOptions.map((item, index) => {
                      return (
                        <button
                          onClick={
                            () =>
                              dispatch(
                                setAccountTypeForDash(item.name?.toLowerCase())
                              )
                            // setParams((pre) => ({
                            //   ...pre,
                            //   size: item.value,
                            // }))
                          }
                          key={index}
                          // className={`filterBtns ${
                          //   params?.size === item.value ? "active" : ""
                          // }`}
                          className={`filterBtns ${
                            accountTypeForDash === item.name?.toLowerCase()
                              ? "active"
                              : ""
                          }`}
                        >
                          {item?.name}
                        </button>
                      );
                    })}
                  </div>
                </div>
                <div className="acntDetailFilter">
                  <p>Account Type</p>
                  <div className="filterOptionWrapper">
                    {" "}
                    {accntTypeOptions?.length &&
                      accntTypeOptions?.map((data, key) => {
                        return (
                          <button
                            // onClick={() =>
                            //   // dispatch(setAccountType(data?.toLowerCase()))
                            //   setParams((pre) => ({
                            //     ...pre,
                            //     plan_type: data.value,
                            //   }))
                            // }
                            // key={key}
                            // className={`filterBtns ${
                            //   params?.plan_type === data?.value ? "active" : ""
                            // }`}
                            onClick={() =>
                              dispatch(
                                setAccountType(data?.value?.toLowerCase())
                              )
                            }
                            key={key}
                            className={`filterBtns ${
                              accountType === data?.value?.toLowerCase()
                                ? "active"
                                : ""
                            }`}
                          >
                            {data.name}
                          </button>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="addBtnBox">
            <button
              className="add-acc-btn"
              onClick={() => navigate("/FundingEvaluationPayments/89")}
              startIcon={AddIcon}
            >
              Add Account
            </button>
          </div>
        </div>
        <div className="dashboardTableContainer">
          <ReactTable
            columns={columns}
            data={newFilterValues || []}
            setParams={setParams}
            params={params}
          />
        </div>
      </div>
      <CredentialComp
        credentialVisible={credentialVisible}
        setCredentialVisible={setCredentialVisible}
        credentialData={credentialData}
      />
    </div>
  );
};

export default ActiveAccounts;

const CredentialComp = ({
  row,
  credentialData,
  credentialVisible,
  setCredentialVisible,
}) => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const credentialCompRef = useRef(null);
  console.log(credentialData, "credentialDatacredentialData");
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        credentialCompRef.current &&
        !credentialCompRef.current.contains(event.target)
      ) {
        setCredentialVisible(false);
        setPasswordVisible(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [setCredentialVisible]);

  const handleNavigationLinks = (url) => {
    window.open(url, "_blank");
  };

  useEffect(() => {
    if (credentialVisible) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [credentialVisible]);

  return (
    <div
      className={`credentialCompContainer ${
        credentialVisible ? "traderVisible" : "traderHidden"
      }`}
    >
      <div ref={credentialCompRef} className="credentialCompWrapper">
        <h4 className="credentialHeader">Login Credentials</h4>
        <div className={`credentialDataWrapper`}>
          <div className="credentialDataBox">
            <label htmlFor="">Login</label>
            <div className="valueBox">
              <div className="value">
                <p>{credentialData?.login_id || "NA"}</p>
                <CopyToClipboard
                  onCopy={() => handleCopyToClipboard("Login ID Copied!")}
                  text={credentialData?.login_id}
                >
                  <DoubleCopyButton style={{ cursor: "pointer" }} />
                </CopyToClipboard>
              </div>
            </div>
          </div>
          {credentialData?.platform === "mt5" && (
            <div className="credentialDataBox">
              <label htmlFor="">Password</label>
              <div className="valueBox">
                <div className="value">
                  <p>
                    {(passwordVisible
                      ? credentialData?.password
                      : "*********") || "NA"}{" "}
                    <button
                      onClick={() => setPasswordVisible(!passwordVisible)}
                    >
                      {passwordVisible ? <EyeIcon /> : <EyeSlashedIcon />}
                    </button>
                  </p>
                  <CopyToClipboard
                    onCopy={() =>
                      handleCopyToClipboard("Master password Copied!")
                    }
                    text={credentialData?.password}
                  >
                    <DoubleCopyButton style={{ cursor: "pointer" }} />
                  </CopyToClipboard>
                </div>
              </div>
            </div>
          )}
          {/* <div className="credentialDataBox">
            <label htmlFor="">Read-only password</label>
            <div className="valueBox">
              <div className="value">
                <p>{credentialData?.value || "NA"}</p>
                <CopyToClipboard
                  onCopy={() =>
                    handleCopyToClipboard("Read-only password Copied!")
                  }
                  text={credentialData?.value}
                >
                  <DoubleCopyButton style={{ cursor: "pointer" }} />
                </CopyToClipboard>
              </div>
            </div>
          </div> */}
          <div className="credentialDataBox">
            <label htmlFor="">Server</label>
            <div className="valueBox">
              <div className="value">
                <p>{credentialData?.server || "NA"}</p>
                <CopyToClipboard
                  onCopy={() => handleCopyToClipboard("Server Copied!")}
                  text={credentialData?.server}
                >
                  <DoubleCopyButton style={{ cursor: "pointer" }} />
                </CopyToClipboard>
              </div>
            </div>
          </div>
          <div className="credentialDataBox">
            <label htmlFor="">Platform</label>
            <div className="valueBox">
              <div className="value">
                <p style={{ textTransform: "uppercase" }}>
                  {credentialData?.platform || "NA"}
                </p>
                {credentialData?.platform === "mt5" ? (
                  <div className="websiteLinks">
                    <WindowsIcon
                      onClick={() =>
                        handleNavigationLinks(
                          "https://download.mql5.com/cdn/web/acg.markets.limited/mt5/acgmarkets5setup.exe"
                        )
                      }
                      style={{ cursor: "pointer" }}
                    />
                    <MacIcon
                      onClick={() =>
                        handleNavigationLinks(
                          "https://download.mql5.com/cdn/mobile/mt5/ios?server=ACGMarkets-Main"
                        )
                      }
                      style={{ cursor: "pointer" }}
                    />
                    <AndroidIcon
                      onClick={() =>
                        handleNavigationLinks(
                          "https://download.mql5.com/cdn/mobile/mt5/android?server=ACGMarkets-Main"
                        )
                      }
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                ) : credentialData?.platform === "dxtrade" ? (
                  <div className="websiteLinks">
                    <WebPortalIcon
                      onClick={() =>
                        handleNavigationLinks(
                          "https://dxtrade.alphacapitalgroup.uk/"
                        )
                      }
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                ) : credentialData?.platform === "ctrader" ? (
                  <div className="websiteLinks">
                    <WindowsIcon
                      onClick={() =>
                        handleNavigationLinks(
                          "https://getctrader.com/acgmarkets/ctrader-acgmarkets-setup.exe"
                        )
                      }
                      style={{ cursor: "pointer" }}
                    />
                    <MacIcon
                      onClick={() =>
                        handleNavigationLinks(
                          "https://getctradermac.com/acgmarkets/ctrader-acgmarkets-setup.dmg"
                        )
                      }
                      style={{ cursor: "pointer" }}
                    />
                    <WebPortalIcon
                      onClick={() =>
                        handleNavigationLinks(
                          "https://app.ctrader.com/?mainSource=mailer&additionalSource=cta"
                        )
                      }
                      style={{ cursor: "pointer" }}
                    />
                  </div>
                ) : (
                  ""
                )}
                {/* <CopyToClipboard
                  onCopy={() => handleCopyToClipboard("Platform Copied!")}
                  text={credentialData?.platform}
                >
                  <DoubleCopyButton style={{ cursor: "pointer" }} />
                </CopyToClipboard> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// const ReactTable = ({ columns, data, params, setParams }) => {
//   const [currentPage, setCurrentPage] = useState(params?.page_number || 1);
//   const [gotoPageInput, setGotoPageInput] = useState("");
//   const [isSmallScreen, setIsSmallScreen] = useState(false);

//   const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
//     useTable({
//       columns,
//       data: data?.results || [],
//     });

//   const totalPages = Math.ceil(data?.count / params?.page_size);

//   useEffect(() => {
//     const handleResize = () => {
//       setIsSmallScreen(window.innerWidth < 650);
//     };

//     handleResize();
//     window.addEventListener("resize", handleResize);
//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);

//   const handleGotoPage = () => {
//     const pageNumber = parseInt(gotoPageInput, 10);
//     if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= totalPages) {
//       setParams((prev) => ({ ...prev, page_number: pageNumber }));
//       setCurrentPage(pageNumber);
//       setGotoPageInput("");
//     }
//   };

//   const handlePageChange = (event, page) => {
//     setParams((prev) => ({ ...prev, page_number: page }));
//     setCurrentPage(page);
//   };

//   const handlePageSizeChange = (event) => {
//     const newPageSize = parseInt(event.target.value, 10);
//     if (newPageSize !== params?.page_size) {
//       setParams((prev) => ({
//         ...prev,
//         page_size: newPageSize,
//         page_number: 1,
//       }));
//       setCurrentPage(1);
//     }
//   };

//   const formatPageNumber = (page) => (page < 10 ? `0${page}` : page);

//   return (
//     <div className="main_table">
//       <div className="table_container">
//         <table {...getTableProps()} className="table">
//           <thead className="table_head">
//             {headerGroups.map((headerGroup) => (
//               <tr {...headerGroup.getHeaderGroupProps()} className="head_row">
//                 {headerGroup.headers.map((column) => (
//                   <th {...column.getHeaderProps()}>
//                     {column.render("Header")}
//                   </th>
//                 ))}
//               </tr>
//             ))}
//           </thead>
//           <tbody
//             {...getTableBodyProps()}
//             className={`table_tbody ${data?.count === 0 ? "noDataBody" : ""}`}
//           >
//             {data?.count === 0 ? (
//               <tr>
//                 <td colSpan={columns.length} className="no-data-message">
//                   No data available
//                 </td>
//               </tr>
//             ) : (
//               rows.map((row, index) => {
//                 prepareRow(row);
//                 return (
//                   <tr {...row.getRowProps()} className="tbody_row" key={index}>
//                     {row.cells.map((cell) => (
//                       <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
//                     ))}
//                   </tr>
//                 );
//               })
//             )}
//           </tbody>
//         </table>
//       </div>

//       {totalPages > 0 && (
//         <div className="paginationComponent">
//           <div className="pagination_container">
//             <Pagination
//               count={totalPages}
//               page={currentPage}
//               onChange={handlePageChange}
//               boundaryCount={2}
//               siblingCount={1}
//               variant="outlined"
//               shape="rounded"
//               renderItem={(item) => (
//                 <PaginationItem
//                   {...item}
//                   components={{
//                     previous: () => (
//                       <Button
//                         variant="outlined"
//                         onClick={() => handlePageChange(null, currentPage - 1)}
//                         disabled={currentPage === 1}
//                       >
//                         {isSmallScreen ? "<" : "< Previous"}
//                       </Button>
//                     ),
//                     next: () => (
//                       <Button
//                         variant="outlined"
//                         onClick={() => handlePageChange(null, currentPage + 1)}
//                         disabled={currentPage === totalPages}
//                       >
//                         {isSmallScreen ? ">" : "Next >"}
//                       </Button>
//                     ),
//                   }}
//                   page={formatPageNumber(item.page)}
//                 />
//               )}
//             />
//           </div>
//           <div className="pageSizeSelectorComponent">
//             <div className="goto-page-input">
//               <input
//                 type="number"
//                 placeholder="Go to Page"
//                 value={gotoPageInput}
//                 onChange={(e) => setGotoPageInput(e.target.value)}
//               />
//               <button className="goToButton" onClick={handleGotoPage}>
//                 Go
//               </button>
//             </div>
//             <Select
//               className="pageSizeSelector"
//               value={params?.page_size || 10}
//               onChange={handlePageSizeChange}
//               displayEmpty
//               inputProps={{ "aria-label": "Page Size Selector" }}
//               sx={{
//                 ".MuiSelect-icon": {
//                   color: "white", // Makes the SVG icon white
//                 },
//               }}
//             >
//               {[10, 20, 30, 50, 100].map((size) => (
//                 <MenuItem key={size} value={size}>
//                   {size} / page
//                 </MenuItem>
//               ))}
//             </Select>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };
